export function escapeSingleQuotes(str) {
    if (!str) {
        return str;
    }
    // Replace single quotes with escaped single quotes
    // Only when the single quote is not preceded by a backslash
    return str.replace(/(?<!\\)'/g, "\\'");
}
//# sourceMappingURL=escapeSingleQuotes.js.map